import {
  IconButton,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  List,
  ListItem,
  Typography,
  Stack,
  AppBar,
  OutlinedInput,
  InputAdornment,
  ListItemText,
  Snackbar,
  Alert,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import PostAddIcon from "@mui/icons-material/PostAdd";
// import NextPlanIcon from "@mui/icons-material/NextPlan";
import React, { useEffect, useState } from "react";
import Confirmdialog from "./Confirmdialog";
import { markConditioninCC, addCustomXmlPart } from "../../../utilities/Wordutil";

/* global Word */

const Markcondition = (props: any) => {
  const [opendlg, setOpendlg] = React.useState(false);
  const [value, setValue] = React.useState({});
  const [popupopen, setpopupopen] = React.useState(false);
  const [message, setmessage] = React.useState("");
  const [clausetext, setclausetext] = React.useState("");
  const [appliesto, setappliesto] = React.useState("");
  const [IsAgreementSel, setIsAgreementSel] = useState(false);
  const [resultmsg, setresultmsg] = useState("");
  const [operators, setoperators] = useState([]);

  const handleClosedlg = (newValue?: any) => {
    setOpendlg(false);
    console.log("Dialog closed => " + value);
    console.log("Dialog new value closed => " + newValue);
    if (newValue) {
      console.log("New value selected");
      console.log(newValue);
      setValue(newValue);
      formvalues.fieldname = newValue.value;
      if (newValue.selobject != null && newValue.selobject.id.indexOf("Agreement__c") >= 0) {
        setIsAgreementSel(true);
      } else {
        setIsAgreementSel(false);
      }
      //Check for data type
      setoperators(operaDic);
      if (newValue.selobject != null) {
        var selfldatatype = newValue.selobject.type;
        if(datatypesflds.toLowerCase().indexOf("||" + selfldatatype + "||") === -1) {
          var listoperators = operaDic.filter((item)=> item.name.indexOf("greater")===-1 && item.name.indexOf("less")===-1);
          setoperators(listoperators);
        }
      }
      //Ends here
    }
  };

  const defFormValues = {
    fieldname: "",
    operator: "",
    checkvalue: "",
  };

  const datatypesflds = "||Currency||Date||Date/Time||Number||Percent||Time||Double||";

  const operaDic = [
    { symbol: "=", name: "equals" },
    { symbol: "!=", name: "not equals to" },
    { symbol: "LIKE%", name: "starts with" },
    { symbol: "NOT LIKE%", name: "does not starts with" },
    { symbol: "%LIKE", name: "ends with" },
    { symbol: "NOT %LIKE", name: "does not ends with" },
    { symbol: "%LIKE%", name: "contains" },
    { symbol: "NOT %LIKE%", name: "does not contains" },
    { symbol: ">", name: "greater than" },
    { symbol: "<", name: "less than" },
    { symbol: ">=", name: "greater than or equal to" },
    { symbol: "<=", name: "less than or equal to" },
  ];

  const [formvalues, setformvalues] = useState(defFormValues);

  const [buildvalue, setbuildvalue] = useState("");

  const [marklist, setmarklist] = useState([]);

  const handlepopupClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setresultmsg("");
    setpopupopen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setformvalues({
      ...formvalues,
      [name]: value,
    });
  };

  function SetClauseName(e) {
    setclausetext(e.target.value);
  }

  function SetBuildExpression(e) {
    setbuildvalue(e.target.value);
  }

  async function SetConditionsinDoc() {
    setresultmsg("");
    if (props.IsClauses) {
      if (clausetext.length == 0) {
        setresultmsg("error");
        setmessage("Please give clause name");
        setpopupopen(true);
      } else {
        SetClauseCondition();
      }
    } else {
      SetConditioninCC();
    }
  }

  async function SetClauseCondition() {
    if (marklist.length && buildvalue.length > 0) {
      await Word.run(async (context) => {
        let selCCs = context.document.getSelection().parentContentControlOrNullObject;
        context.load(selCCs);
        await context.sync();
        if (selCCs.id == undefined) {
          let selection = context.document.getSelection();
          context.load(selection);
          await context.sync();
          if (selection.text.length == 0) {
            setresultmsg("error");
            setmessage("Please select text to continue");
            setpopupopen(true);
            return;
          }
          selCCs = selection.insertContentControl(Word.ContentControlType.richText);
          selCCs.title = "Clauses";
          selCCs.tag = clausetext;
          await context.sync();
          var newnodexml =
            "<field id='" +
            selCCs.id +
            "'>" +
            "<name>" +
            "Clauses" +
            "</name>" +
            "<label>" +
            "Clauses" +
            "</label>" +
            "<conditions />" +
            "<reference />" +
            "<type>" +
            "Clauses" +
            "</type>" +
            "<sfvalue/>" +
            "</field>";
          await addCustomXmlPart(newnodexml);
        }
        if (selCCs != null) {
          context.load(selCCs);
          await context.sync();
          if (selCCs.id != undefined) {
            markConditioninCC(marklist, selCCs.id, buildvalue, "");
            setclausetext("");
            setmarklist([]);
            setmessage("Conditions marked for Content Control");
            setpopupopen(true);
          } else {
            setresultmsg("error");
            setmessage("Please select content control");
            setpopupopen(true);
          }
        }
      });
    } else {
      if (marklist.length == 0) {
        setresultmsg("error");
        setmessage("Please add conditions");
        setpopupopen(true);
      } else {
        setresultmsg("error");
        setmessage("Please build conditions by filling => 1 OR 2, 1, 1 AND 2");
        setpopupopen(true);
      }
    }
  }

  async function SetConditioninCC() {
    if (marklist.length && buildvalue.length > 0) {
      console.log(appliesto);
      let isMarked = false;
      if (appliesto.toLowerCase() === "individual column" || appliesto === "") {
        await Word.run(async (context) => {
          let selectionID = 0;
          let getselparent = context.document.getSelection().contentControls.getFirstOrNullObject();
          if (getselparent != null) {
            context.load(getselparent);
            await context.sync();
            if (getselparent.title === "Fields") {
              selectionID = getselparent.id;
            }
          }
          if (selectionID === 0) {
            getselparent = context.document.getSelection().parentContentControlOrNullObject;
            context.load(getselparent);
            await context.sync();
            if (getselparent.title === "Fields") {
              selectionID = getselparent.id;
            }
          }
          if (selectionID != 0) {
            markConditioninCC(marklist, selectionID, buildvalue, "");
            isMarked = true;
          }
        });
      } else if (appliesto.toLowerCase() === "whole table" || appliesto.toLowerCase() === "whole row") {
        await Word.run(async (context) => {
          let selectionID = 0;
          let getseltable = context.document.getSelection().parentTableOrNullObject;
          if (getseltable != null) {
            context.load(getseltable);
            await context.sync();
            let getselparent = getseltable.parentContentControlOrNullObject;
            context.load(getselparent);
            await context.sync();
            if (getselparent.title === "Repeat") {
              selectionID = getselparent.id;
            }
            if (selectionID != 0 && appliesto.toLowerCase() === "whole table") {
              markConditioninCC(marklist, selectionID, buildvalue, "");
              isMarked = true;
            } else if (selectionID != 0 && appliesto.toLowerCase() === "whole row") {
              markConditioninCC(marklist, selectionID, buildvalue, "", true);
              isMarked = true;
            }
          }
        });
      }
      if (isMarked) {
        setmarklist([]);
        setmessage("Conditions marked for Content Control");
        setpopupopen(true);
      } else {
        setresultmsg("error");
        setmessage("Please select content control");
        setpopupopen(true);
      }
      // // await Word.run(async (context) => {
      // //   //let selCCs = context.document.getSelection().parentContentControlOrNullObject;
      // //   let isMarked = false;
      // //   let getselparent = context.document.getSelection().parentContentControlOrNullObject;
      // //   context.load(getselparent);
      // //   await context.sync();
      // //   console.log("To Know the selection...");
      // //   console.log(getselparent.id);
      // //   if (getselparent.id != undefined) {
      // //     console.log("INN Selection...");
      // //     markConditioninCC(marklist, getselparent.id, buildvalue, "");
      // //     isMarked = true;
      // //   } else {
      // //     console.log("Not INN Selection...");
      // //     let getsel = context.document.getSelection();
      // //     context.load(
      // //       getsel,
      // //       "contentcontrols,contentcontrols/items,contentcontrols/items/id,contentcontrols/items/parentContentControlOrNullObject,contentcontrols/items/parentContentControlOrNullObject/id"
      // //     );
      // //     await context.sync();
      // //     if (getsel != null && getsel.contentControls.items.length > 0) {
      // //       let selcomp = [];
      // //       for (var h = 0; h < getsel.contentControls.items.length; h++) {
      // //         let selCCs = getsel.contentControls.items[h];
      // //         selcomp.push(selCCs.getRange().compareLocationWith(getsel));
      // //       }
      // //       await context.sync();
      // //       let onetime = 0;
      // //       for (var t = 0; t < selcomp.length; t++) {
      // //         console.log(selcomp[t].value);
      // //         if (selcomp[t].value.indexOf("Equal") >= 0 || selcomp[t].value.indexOf("ContainsEnd") >= 0) {
      // //           console.log("[Equal]");
      // //           let selCCs = getsel.contentControls.items[t];
      // //           markConditioninCC(marklist, selCCs.id, buildvalue, "");
      // //           isMarked = true;
      // //           break;
      // //         } else if (selcomp[t].value.indexOf("Inside") >= 0 && onetime == 0) {
      // //           onetime++;
      // //           console.log("[Inside]");
      // //           isMarked = true;
      // //           let selCCs = getsel.contentControls.items[t].parentContentControlOrNullObject;
      // //           console.log(selCCs.id);
      // //           markConditioninCC(marklist, selCCs.id, buildvalue, "", true);
      // //         }
      // //       }
      // //     }
      // //   }
      // //   if (isMarked) {
      // //     setmarklist([]);
      // //     setmessage("Conditions marked for Content Control");
      // //     setpopupopen(true);
      // //   } else {
      // //     setmessage("Please select content control");
      // //     setpopupopen(true);
      // //   }
      // // });
    } else {
      if (marklist.length == 0) {
        setresultmsg("error");
        setmessage("Please add conditions");
        setpopupopen(true);
      } else {
        setresultmsg("error");
        setmessage("Please build conditions by filling => 1 OR 2, 1, 1 AND 2");
        setpopupopen(true);
      }
    }
  }

  const handleRemoveItem = (value) => {
    setmarklist(marklist.filter((item) => item.condition !== value));
  };

  function handleSubmit(event) {
    event.preventDefault();
    if (appliesto.toLowerCase() === "whole table" && !IsAgreementSel) {
      setresultmsg("error");
      setmessage("Please select 'Agreement' fields for whole table");
      setpopupopen(true);
      return;
    } else if (appliesto != "" && appliesto.toLowerCase() != "whole table" && IsAgreementSel) {
      setresultmsg("error");
      setmessage("Please select 'Agreement' fields only for whole table");
      setpopupopen(true);
      return;
    }
    setmarklist([
      ...marklist,
      {
        fieldname: formvalues.fieldname,
        operatorval: operaDic.filter((item) => item.name === formvalues.operator)[0].symbol,
        resultval: formvalues.checkvalue,
        condition:
          formvalues.fieldname +
          " " +
          operaDic.filter((item) => item.name === formvalues.operator)[0].symbol +
          " " +
          formvalues.checkvalue,
      },
    ]);
    setformvalues(defFormValues);
  }

  useEffect(() => {
    setoperators(operaDic);
    if (props.IsTableCondition) {
      setappliesto("Individual column");
    } else {
      setappliesto("");
    }
  }, []);

  return (
    <Box sx={{ p: 1.5, marginTop: 0 }}>
      {/* <Grid item>
        <h3>Define Field condition</h3>
      </Grid> */}
      {props.IsClauses && (
        <Grid>
          <FormControl fullWidth size="small">
            <TextField
              name="clausename"
              label="Enter clause name"
              size="small"
              value={clausetext}
              variant="outlined"
              onChange={SetClauseName}
            />
          </FormControl>
        </Grid>
      )}
      <Accordion
        elevation={0}
        defaultExpanded={true}
        disableGutters={true}
        sx={{
          "& .MuiButtonBase-root": {
            padding: 0,
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography sx={{ color: "#1C39BB", fontWeight: "bold", width: "100%", flexShrink: 0 }}>
            Add Conditions
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0, margin: 0 }}>
          <form onSubmit={handleSubmit}>
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth size="small" variant="outlined">
                  <InputLabel htmlFor="standard-adornment-password">Select field name</InputLabel>
                  <OutlinedInput
                    id="standard-adornment-password"
                    type="text"
                    name="fieldname"
                    value={formvalues.fieldname}
                    onChange={handleInputChange}
                    label="Select field name"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton onClick={() => setOpendlg(true)}>
                          <PostAddIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="operatorsobj">Select Operator</InputLabel>
                  {Object.keys.length > 0 && (
                    <Select
                      labelId="operatorsobj"
                      label="Select Operators"
                      size="small"
                      value={formvalues.operator}
                      name="operator"
                      variant="outlined"
                      onChange={handleInputChange}
                    >
                      {operators.map((item) => (
                        <MenuItem key={item.symbol} value={item.name}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth size="small">
                  <TextField
                    name="checkvalue"
                    label="Value"
                    size="small"
                    value={formvalues.checkvalue}
                    variant="outlined"
                    onChange={handleInputChange}
                  />
                </FormControl>
              </Grid>
              {props.IsTableCondition && (
                <Grid item xs={12}>
                  <FormControl size="small" fullWidth>
                    <InputLabel id="applies">Applies to</InputLabel>
                    <Select
                      id="demo-select-small"
                      name="applies"
                      label="Applies to"
                      value={appliesto}
                      variant="outlined"
                      onChange={(e) => {
                        setappliesto(e.target.value + "");
                      }}
                    >
                      <MenuItem value="Individual column">Individual column</MenuItem>
                      <MenuItem value="Whole row">Whole row</MenuItem>
                      <MenuItem value="Whole table">Whole table</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}
              <Grid item>
                <Button variant="contained" size="small" type="submit" sx={{ bgcolor: "#1C39BB" }}>
                  <Typography sx={{ fontSize: 14 }}>Add</Typography>
                </Button>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
      <Accordion
        elevation={0}
        defaultExpanded={true}
        disableGutters={true}
        sx={{
          "& .MuiButtonBase-root": {
            padding: 0,
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
          <Typography sx={{ color: "#1C39BB", fontWeight: "bold", width: "100%", flexShrink: 0 }}>
            Build Conditions
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0, margin: 0 }}>
          {marklist.length === 0 ? (
            <Typography sx={{ fontStyle: "italic" }} variant="body2">
              No Conditions to list
            </Typography>
          ) : (
            <Grid>
              <Grid item>
                <Stack direction={"row"}>
                  <TextField
                    label="Build Experssion"
                    value={buildvalue}
                    id="fullWidth"
                    multiline
                    maxRows={1}
                    fullWidth
                    onChange={SetBuildExpression}
                  />
                  {/* <IconButton type="button" aria-label="search" onClick={SetConditioninCC}>
                    <NextPlanIcon sx={{ color: "green" }} />
                  </IconButton> */}
                </Stack>
              </Grid>
              <Grid item>
                <List
                  dense
                  sx={{
                    width: "100%",
                    position: "relative",
                    overflow: "auto",
                    maxHeight: 200,
                    marginTop: 2,
                  }}
                >
                  {marklist.map((item, index) => (
                    <ListItem
                      sx={{ margin: "0 px", padding: "0 px" }}
                      divider
                      disablePadding={true}
                      key={index}
                      secondaryAction={
                        <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveItem(item.condition)}>
                          <DeleteIcon sx={{ width: 19, height: 19 }} />
                        </IconButton>
                      }
                    >
                      {/* <ListItemButton
                        sx={{ padding: 0, margin: 0, alignContent: "flex-start", alignItems: "flex-start" }}
                      >
                        <Stack direction={"row"}>
                          <Typography variant="caption" sx={{ color: "orangered" }}>
                            {(index + 1).toString() + "."}
                          </Typography>
                          <Typography variant="caption">&nbsp;</Typography>
                          <Typography variant="caption" sx={{ color: "blue" }}>
                            {item.fieldname}
                          </Typography>
                          <Typography variant="caption">&nbsp;</Typography>
                          <Typography variant="caption" sx={{ color: "red" }}>
                            {item.operatorval}
                          </Typography>
                          <Typography variant="caption">&nbsp;</Typography>
                          <Typography variant="caption" sx={{ color: "green" }}>
                            {item.resultval}
                          </Typography>
                        </Stack>
                      </ListItemButton> */}
                      <ListItemText
                        primary={
                          <Typography
                            sx={{
                              display: "inline",
                              fontSize: 14,
                              "& .MuiTypography-caption": {
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              },
                            }}
                            component="span"
                            variant="caption"
                            color="#1C39BB"
                          >
                            {(index + 1).toString() + ". " + item.fieldname}
                          </Typography>
                        }
                        secondary={
                          <>
                            <Typography
                              sx={{ display: "inline", marginLeft: 1.75 }}
                              component="span"
                              variant="caption"
                              color="orangered"
                            >
                              {item.operatorval}
                            </Typography>
                            {" " + item.resultval}
                          </>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Grid>
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
      <Confirmdialog
        keepMounted
        id="selflddlg"
        open={opendlg}
        onClose={handleClosedlg}
        value={value}
        tablemode={false}
        tablecondition={props.IsTableCondition}
        mainfldid=""
      />
      <Snackbar open={popupopen} autoHideDuration={6000} onClose={handlepopupClose}>
        <Alert onClose={handlepopupClose} severity={resultmsg === "error" ? "error" : "success"} sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
      <AppBar position="fixed" sx={{ top: "auto", bottom: 0 }}>
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            size="small"
            onClick={SetConditionsinDoc}
            sx={{ width: "100%", bgcolor: "#1C39BB" }}
          >
            <Typography>Mark Condition</Typography>
          </Button>
        </Stack>
      </AppBar>
    </Box>
  );
};

export default Markcondition;
